(function () {
  // ===== Money formatter =====
  window.formatMoney = function (cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = format || '${{amount}}';

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision || 2;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number == null) return 0;
      number = (number / 100.0).toFixed(precision);
      const parts = number.split('.');
      const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      const centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }

    let value = '';
    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount': value = formatWithDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = formatWithDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = formatWithDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = formatWithDelimiters(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = formatWithDelimiters(cents, 0, ' ', ''); break;
      default: value = formatWithDelimiters(cents, 2);
    }
    return formatString.replace(placeholderRegex, value);
  };

  // ===== Shipping bar state =====
  window._shipBar = {
    lastWidth: 0,
    pendingCart: null,
    isProcessing: false,
    barWasInDom: false,
    firstAddInProgress: false
  };

  (function () {
    const bar = document.querySelector('.cart-drawer-shipping');
    if (bar && bar.dataset.targetPercent) {
      window._shipBar.lastWidth = parseFloat(bar.dataset.targetPercent);
      window._shipBar.barWasInDom = true;
    } else {
      window._shipBar.lastWidth = 0;
      window._shipBar.barWasInDom = false;
    }
  })();

  window._calcShipPercent = function (cartData, shippingBarEl) {
    const threshold = parseInt(shippingBarEl.dataset.threshold) || 150000;
    let p = (cartData.total_price / threshold) * 100;
    if (p > 100) p = 100;
    if (p < 0) p = 0;
    return p;
  };

  window._updateShipText = function (cartData, shippingBarEl) {
    const threshold = parseInt(shippingBarEl.dataset.threshold) || 150000;
    const progressText = shippingBarEl.dataset.progressText || 'Add {amount} more and get a free shipping!';
    const successText = shippingBarEl.dataset.successText || 'Congratulations! You got free shipping!';
    const moneyFormat = shippingBarEl.dataset.moneyFormat || '${{amount}}';
    const messageSpan = shippingBarEl.querySelector('.free-shipping-message');

    if (cartData.total_price >= threshold) {
      if (messageSpan) messageSpan.innerHTML = successText;
      shippingBarEl.classList.add('free-shipping-unlocked');
    } else {
      if (messageSpan) {
        const remaining = threshold - cartData.total_price;
        const remainingFormatted = new Intl.NumberFormat(shippingBarEl.dataset.locale || 'en', {
          style: 'currency', currency: cartData.currency || shippingBarEl.dataset.currency || 'CZK',
          minimumFractionDigits: 0, maximumFractionDigits: 2
        }).format(remaining / 100);
        messageSpan.innerHTML = progressText.replace('{amount}', remainingFormatted);
      }
      shippingBarEl.classList.remove('free-shipping-unlocked');
    }
  };

  // ===== First-add animation (empty cart -> first product) =====
  window._animateFirstAdd = async function () {
    if (window._shipBar.firstAddInProgress) return;
    window._shipBar.firstAddInProgress = true;

    try {
      const bar = document.querySelector('.cart-drawer-shipping');
      if (!bar) return;
      const progressBar = bar.querySelector('.free-shipping-progress');
      if (!progressBar) return;

      progressBar.style.transition = 'none';
      progressBar.style.width = '0%';
      void progressBar.offsetHeight;

      let cartData = window._shipBar.pendingCart;
      if (!cartData) {
        try {
          const res = await fetch('/cart.js', { cache: 'no-store' });
          cartData = await res.json();
        } catch (e) {
          return;
        }
      }

      const targetPercent = window._calcShipPercent(cartData, bar);
      window._updateShipText(cartData, bar);

      progressBar.style.transition = 'none';
      progressBar.style.width = '0%';
      void progressBar.offsetHeight;

      await new Promise(resolve => requestAnimationFrame(resolve));
      await new Promise(resolve => requestAnimationFrame(resolve));

      progressBar.style.removeProperty('transition');
      void progressBar.offsetHeight;
      progressBar.style.width = targetPercent + '%';

      window._shipBar.lastWidth = targetPercent;
      window._shipBar.barWasInDom = true;
      window._shipBar.pendingCart = null;
      window._shipBar.isProcessing = false;
    } finally {
      setTimeout(() => {
        window._shipBar.firstAddInProgress = false;
      }, 100);
    }
  };

  // ===== Standard animation for normal updates =====
  window._animateShipBar = function () {
    const bar = document.querySelector('.cart-drawer-shipping');
    if (!bar) {
      window._shipBar.isProcessing = false;
      return;
    }
    const progressBar = bar.querySelector('.free-shipping-progress');
    if (!progressBar) {
      window._shipBar.isProcessing = false;
      return;
    }
    if (window._shipBar.pendingCart === null) return;

    const targetPercent = window._calcShipPercent(window._shipBar.pendingCart, bar);
    const oldWidth = window._shipBar.lastWidth;

    progressBar.style.transition = 'none';
    progressBar.style.width = oldWidth + '%';
    void progressBar.offsetHeight;

    window._updateShipText(window._shipBar.pendingCart, bar);

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        progressBar.style.removeProperty('transition');
        progressBar.style.width = targetPercent + '%';
        window._shipBar.lastWidth = targetPercent;
        window._shipBar.pendingCart = null;
        window._shipBar.isProcessing = false;
        window._shipBar.barWasInDom = true;
      });
    });
  };

  window._forceWidthOverride = function () {
    if (!window._shipBar.isProcessing) return;
    if (window._shipBar.firstAddInProgress) return;
    const bar = document.querySelector('.cart-drawer-shipping');
    if (!bar) return;
    const progressBar = bar.querySelector('.free-shipping-progress');
    if (!progressBar) return;
    if (!window._shipBar.barWasInDom) return;

    const currentWidth = parseFloat(progressBar.style.width);
    if (currentWidth !== window._shipBar.lastWidth) {
      progressBar.style.transition = 'none';
      progressBar.style.width = window._shipBar.lastWidth + '%';
      void progressBar.offsetHeight;
    }
  };

  // ===== Cart slider init =====
  window.initCartSlider = function () {
    const $slider = $('.cart-products-wrapper');
    if ($slider.length === 0) return;
    if ($slider.hasClass('slick-initialized')) $slider.slick('unslick');
    $slider.slick({ slidesToShow: 3, slidesToScroll: 1, infinite: false, arrows: false, dots: false });
  };

  function _initialSetup() {
    window.initCartSlider();
  }
  document.addEventListener('DOMContentLoaded', _initialSetup);
  if (document.readyState !== 'loading') _initialSetup();

  // ===== MutationObserver — handles first-add and normal updates =====
  const cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer) {
    const observer = new MutationObserver(function () {
      const slider = cartDrawer.querySelector('.cart-products-wrapper');
      if (slider && !slider.classList.contains('slick-initialized')) {
        window.initCartSlider();
      }
  
      const bar = cartDrawer.querySelector('.cart-drawer-shipping');

      if (bar && !window._shipBar.barWasInDom) {
        const progressBar = bar.querySelector('.free-shipping-progress');
        if (progressBar) {
          progressBar.style.transition = 'none';
          progressBar.style.width = '0%';
          void progressBar.offsetHeight;
        }
        window._animateFirstAdd();
      }
      else if (!bar && window._shipBar.barWasInDom) {
        window._shipBar.barWasInDom = false;
        window._shipBar.lastWidth = 0;
      }
      else if (bar && window._shipBar.barWasInDom) {
        window._forceWidthOverride();
      }
    });
    observer.observe(cartDrawer, { childList: true, subtree: true });
  }

  // ===== Custom add button (cart drawer recommendations) - OPTIMIZED =====
  document.addEventListener('click', function (e) {
    if (e.target.classList.contains('cart-product-add')) {
      const btn = e.target;
      const variantId = btn.getAttribute('data-variant-id');
      const originalText = btn.innerText;
      btn.disabled = true;
      btn.innerText = btn.dataset.addingText || 'Adding...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
      })
        .then((res) => res.json())
        .then(() => Promise.all([
          fetch('/?sections=cart-drawer').then((r) => r.json()),
          fetch('/cart.js').then((r) => r.json()),
        ]))
        .then(([sectionData, cartData]) => {
          const drawer = document.querySelector('cart-drawer');
          if (drawer && sectionData['cart-drawer']) {
            const $oldSlider = $(drawer).find('.cart-products-wrapper');
            if ($oldSlider.hasClass('slick-initialized')) $oldSlider.slick('unslick');

            // Check if this is first add (empty cart -> one item)
            const isFirstAdd = cartData.item_count === 1;

            window._shipBar.pendingCart = cartData;
            window._shipBar.isProcessing = true;

            const parser = new DOMParser();
            const doc = parser.parseFromString(sectionData['cart-drawer'], 'text/html');
            const newDrawerContent = doc.querySelector('cart-drawer');
            if (newDrawerContent) drawer.innerHTML = newDrawerContent.innerHTML;
            else drawer.innerHTML = sectionData['cart-drawer'];

            drawer.classList.remove('is-empty');
            drawer.classList.add('active');
            window.initCartSlider();
        
            // Trigger correct animation based on cart state
            if (isFirstAdd) {
              console.log('[Cart] First item added - triggering first-add animation');
              window._animateFirstAdd();
            } else {
              console.log('[Cart] Normal update - animating shipping bar');
              window._animateShipBar();
            }

            // Re-enable button
            btn.disabled = false;
            btn.innerText = originalText;
          }
        })
        .catch((err) => {
          console.error('[Add to Cart Error]:', err);
          btn.disabled = false;
          btn.innerText = originalText;
        });
    }
  });

  // ===== Fetch interceptor for normal cart updates =====
  (function () {
    const originalFetch = window.fetch;
    window.fetch = function (...args) {
      const url = args[0];
      const isCartChange =
        typeof url === 'string' &&
        (url.includes('/cart/change') ||
          url.includes('/cart/update') ||
          url.includes('/cart/add') ||
          url.includes('/cart/clear'));

      if (isCartChange) {
        window._shipBar.isProcessing = true;
      }

      return originalFetch.apply(this, args).then((response) => {
        if (isCartChange && response.ok) {
          const cloned = response.clone();
          cloned.json().then((cartData) => {
            if (cartData && typeof cartData.total_price !== 'undefined') {
              window._shipBar.pendingCart = cartData;

              const tryAnimate = (attempt) => {
                if (window._shipBar.firstAddInProgress) return;

                const bar = document.querySelector('.cart-drawer-shipping');
                if (bar) {
                  if (window._shipBar.barWasInDom) {
                    window._animateShipBar();
                  }
                } else if (attempt < 30) {
                  setTimeout(() => tryAnimate(attempt + 1), 50);
                } else {
                  window._shipBar.isProcessing = false;
                }
              };
              setTimeout(() => tryAnimate(0), 100);
            }
          }).catch(() => {
            window._shipBar.isProcessing = false;
          });
        } else if (isCartChange) {
          window._shipBar.isProcessing = false;
        }
        return response;
      }).catch((err) => {
        if (isCartChange) window._shipBar.isProcessing = false;
        throw err;
      });
    };
  })();

})();
